import { StorefrontProductResult } from './Models/StorefrontProductResult';
import { HsContext } from '../../Utils';

export class StorefrontClient {
    baseUrl: string;
    storeId: string;
    languageCode: string;
    baseWebUrl: string;
    entitiesPerPage: number;
    width: number;
    height: number;
    imageExtension: string;

    constructor(context: HsContext, cookieProvider: any, entitiesPerPage: number, imageExtension: string, width: number, height: number) {
        this.baseUrl = context.apiUrl;
        this.imageExtension = imageExtension;
        this.width = width;
        this.height = height;
        this.baseWebUrl = context.storefrontUrl;
        this.storeId = context.store || cookieProvider.getStoreId() || 'global';
        this.languageCode = context.language;
        this.entitiesPerPage = entitiesPerPage;
    }

    createUrlToProduct(id: string, familyId: string, store: string, languageCode: string, configurationCode: string, isExactMatchCode: boolean) {
        if (isExactMatchCode) {
            return `${this.baseWebUrl}/${store}/${languageCode}/code/${configurationCode}`;
        }
        
        return `${this.baseWebUrl}/${store}/${languageCode}/products/${familyId}?model=${id}`
    }

    async getProductResults(query: string, offset: number) {
        const search = new URLSearchParams();
        search.append('phrase', query);
        search.append('skip', offset.toString());
        search.append('take', this.entitiesPerPage.toString());
        search.append('store', this.storeId);
        search.append('language', this.languageCode);

        if (this.imageExtension) {
            search.append('extension', this.imageExtension);
        }
        if (this.width) {
            search.append('imageWidth', this.width.toString());
        }
        if (this.height) {
            search.append('imageHeight', this.height.toString());
        }

        let url = this.baseUrl + '/search/products?' + search.toString();
        const response = await fetch(url);
        const result = (await response.json()) as StorefrontProductResult;
        return result;
    }
}
